import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { imageError } from '../utils/imageError';
import { DataStore } from '../stores';
import Icon from './Icon';
import { Theme } from '../models/Theme';
import { FundManager } from '../models/entity';
import { FundManagers as FundManagersConfig } from '../models/configuration/components/FundManagers';
import { FundManagerImageOptions } from '../models/configuration/FundManagerImageOptions';
import { getExtendedValue } from '../utils/getExtendedValue';

const ImageContainer = styled<any, any>(
    'div',
    'imageContainer',
    'fundManagerImage'
)`
    ${propStyles};
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
`;

ImageContainer.defaultProps = {
    alignSelf: 'center',
    display: 'block',
    height: ['80px', '120px'],
    width: ['80px', '120px'],
    marginY: ['sm', '0'],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'gray300',
    borderRadius: '120px',
    bgColor: 'gray100',
};

const Image = styled<any, any>('img', 'image', 'fundManagerImage')`
    ${propStyles};
    position: relative;
    z-index: 1;
    overflow: hidden;
    text-indent: -100em; /* hides alt text */
`;

Image.defaultProps = {
    display: 'block',
    width: '100%',
};

interface FundManagerImage {
    theme?: Theme;
    dataStore?: DataStore;
    fundManager?: FundManager;
    orchestrationImageSrc?: string;
    config?: FundManagersConfig;
}

@inject('dataStore')
@observer
class FundManagerImage extends Component<FundManagerImage> {
    constructor(props) {
        super(props);
    }

    @computed
    get fundManagersConfig(): FundManagersConfig {
        return this.props.config;
    }

    @computed
    get image(): FundManagerImageOptions {
        const { image } = this.fundManagersConfig;
        return image;
    }

    @computed
    get imageSrc(): string {
        const { fundManager, dataStore, orchestrationImageSrc } = this.props;

        // This is the image src that is setup by the Fund Manager Orchestration component
        if (orchestrationImageSrc) {
            return orchestrationImageSrc;
        }

        // This sets up the standard image from the Fund Manager
        if (this.image && this.image.property) {
            const image = getExtendedValue(
                this.image.property,
                fundManager.extended
            );

            return image;
        } else {
            const imgSrc = `${dataStore.baseUrl}/fund/fundmanagerpicture?code=${fundManager.code}&token=${dataStore.token}`;
            return imgSrc;
        }
    }

    @computed
    get showImage(): boolean {
        const { showImage } = this.fundManagersConfig;
        return showImage;
    }

    render() {
        const { theme, fundManager } = this.props;

        if (!this.showImage) {
            return null;
        }

        return (
            <ImageContainer {...theme.FundManagerImage}>
                <Image
                    src={this.imageSrc}
                    alt={fundManager.name}
                    onError={e => imageError(e.target)}
                />
                <Icon
                    fileName="FundManagerPlaceholder"
                    display="block"
                    height="100%"
                    width="100%"
                    {...theme.FundManagerPlaceholderImage}
                />
            </ImageContainer>
        );
    }
}

export default withTheme(FundManagerImage);



// WEBPACK FOOTER //
// ./src/Components/FundManagerImage.tsx